/* Rquiere de mixin.js */

var comuna = {
	data () {
		return {
			listComunas: [],
			methodsComuna: {
				get: 'comunas',
				show: 'comuna/',
			},
			paginationComunas: [],
			searchComunas: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllComunas(page = 1) {
			let parameters = '?search=' + this.searchComunas + '&page=' + page
			this.axiosActionIS(this.apiBackend + this.methodsComuna.get + parameters, 'GET', 'getAllComunasResult')
        },
		getAllComunasResult(response) {
            if(response.data.success) {
                this.listComunas = response.data.data
                this.paginationComunas = response.data.paginate    
            }
            this.getAllComunasResultLocal(response)
		},
        getAllComunasResultLocal(response) {
            console.log('getAllComunasResultLocal no desarrollado', response)
        },
		getComuna(id) {
			this.axiosActionIS(this.apiBackend + this.methodsComuna.show + id, 'GET', 'getComunaResult')
		},
        getComunaResult(response) {
            this.getComunaResultLocal(response)
        },
        getComunaResultLocal(response) {
            console.log('getComunaResultLocal no está desarrollado', response)
        },
	},
};

export default comuna;